import Bucket, { COUNTER_TYPE, COUNTER_UNIT } from './Bucket.js';

const DATA_CAP_ID = 'DATACAP';
const GO_CREDIT_ID = 'GOCRD';
const EU_DATA_ID = 'DTSCH';
const DATA_SHARING_ID = 'SSSDZ';
const DATA_SHARING_BONUS_ID = 'SSSPJ';
const BASE_DATA_ID = 'INTVM';
const BASE_VOICE_ID = 'MINMC';
const BASE_MESSAGES_ID = 'SMSMC';
const BASE_BUCKET_IDS = [BASE_DATA_ID, BASE_VOICE_ID, BASE_MESSAGES_ID];

export default class PostpaidBucket extends Bucket {
  /**
   * Non-monetary overconsumption value of the bucket.
   * Typically only applicable to summary buckets.
   *
   * @return {?number}
   */
  get overconsumption() {
    const overconsumptionNonMonetaryCounters = this._getCountersByType(
      COUNTER_TYPE.OVERCONSUMPTION,
    ).filter(counter => counter.unit !== COUNTER_UNIT.MONETARY);

    if (overconsumptionNonMonetaryCounters.length > 1) {
      throw new Error('More than one overconsumption non-monetary counter.');
    }

    if (overconsumptionNonMonetaryCounters.length === 0) {
      return null;
    }

    return overconsumptionNonMonetaryCounters[0].value;
  }

  /**
   * Monetary overconsumption value of the bucket.
   * Typically only applicable to summary buckets.
   *
   * @return {?number}
   */
  get overconsumptionMonetary() {
    const overconsumptionMonetaryCounters = this._getCountersByType(
      COUNTER_TYPE.OVERCONSUMPTION,
    ).filter(counter => counter.unit === COUNTER_UNIT.MONETARY);

    if (overconsumptionMonetaryCounters.length > 1) {
      throw new Error('More than one overconsumption monetary counter.');
    }

    if (overconsumptionMonetaryCounters.length === 0) {
      return null;
    }

    return overconsumptionMonetaryCounters[0].value;
  }

  /**
   * @return {boolean}
   */
  get isDataCap() {
    return this.id === DATA_CAP_ID;
  }

  /**
   * @return {boolean}
   */
  get isGoCredit() {
    return this.id === GO_CREDIT_ID;
  }

  /**
   * @return {boolean}
   */
  get isEuData() {
    return this.id === EU_DATA_ID;
  }

  /**
   * @return {boolean}
   */
  get isDataSharing() {
    return this.id === DATA_SHARING_ID;
  }

  /**
   * @return {boolean}
   */
  get isDataSharingBonus() {
    return this.id === DATA_SHARING_BONUS_ID;
  }

  /**
   * @return {boolean}
   */
  get isDetail() {
    return !this.isSummary && !this.isCredit && !this.isBonusCredit;
  }

  /**
   * @return {boolean}
   */
  get isBaseBucket() {
    return BASE_BUCKET_IDS.includes(this.id);
  }

  /**
   * A completely empty bucket is one that has 0 size and 0 usage.
   *
   * @return {boolean}
   */
  get isEmpty() {
    return !this.total && !this.used;
  }
}
